<div class="lp-product-request-list-header">
  <div class="lp-product-request-list-header__wrapper">
    <button
      tuiIconButton
      type="button"
      [appearance]="isDesktop ? 'secondary' : 'icon'"
      [size]="isDesktop ? 'l' : 'm'"
      iconStart="@tui.chevron-left"
      (click)="onClickBackButton()"
    ></button>

    <div class="title">
      <h1>{{ title }}</h1>
    </div>

    <lp-add-button
      [title]="'components.loyaltyProgram.buttons.createProductRequest' | translate"
      (buttonClick)="add.emit()"
    ></lp-add-button>
  </div>
</div>
